import { render } from "./Op.vue?vue&type=template&id=7fc20ce6"
import script from "./Op.vue?vue&type=script&lang=js"
export * from "./Op.vue?vue&type=script&lang=js"

import "./Op.vue?vue&type=style&index=0&id=7fc20ce6&lang=css"

import exportComponent from "C:\\Users\\User\\Documents\\PROJETOS - LEFISC\\front_revisor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__